/** ARCHITECTURE §10.1：市場是路徑區段 `/:market(tw|us)/...`。 */
export type Market = 'tw' | 'us';

export const MARKETS = ['tw', 'us'] as const;

export function isMarket(value: unknown): value is Market {
  return value === 'tw' || value === 'us';
}

/** 幣別與地區設定由 market 單點決定（§10.1：一個地方驅動四件事）。 */
export const MARKET_LOCALE: Record<Market, { locale: string; currency: string; tz: string }> = {
  tw: { locale: 'zh-TW', currency: 'TWD', tz: 'Asia/Taipei' },
  us: { locale: 'en-US', currency: 'USD', tz: 'America/New_York' },
};
